import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  getFgtnEpisodeUrl,
  parseEpisodeNumber,
} from '../../utils/fgtn';
import { fgtnQrBarHeight } from '../../utils/fgtnQrCard';
import FgtnQrArt from './FgtnQrArt';
import './Fgtn.css';

function qrSizeForViewport() {
  if (typeof window === 'undefined') return 520;
  const viewW = window.innerWidth;
  const viewH = window.innerHeight;
  const sample = Math.min(viewW, viewH);
  const bar = fgtnQrBarHeight(sample);
  return Math.max(240, Math.floor(Math.min(viewW, viewH - bar * 2)));
}

export default function FgtnQrPage() {
  const { episodeNumber: episodeParam } = useParams();
  const episodeNumber = parseEpisodeNumber(episodeParam);
  const url = episodeNumber ? getFgtnEpisodeUrl(episodeNumber) : '';
  const [qrSize, setQrSize] = useState(qrSizeForViewport);

  useEffect(() => {
    const update = () => setQrSize(qrSizeForViewport());
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  useEffect(() => {
    document.title = episodeNumber
      ? `FGTN Episode ${episodeNumber} QR | Angler Built`
      : 'FGTN QR | Angler Built';
  }, [episodeNumber]);

  if (!episodeNumber) {
    return (
      <div className="fgtn-qr-screen">
        <p>That episode number is not valid.</p>
        <Link to="/fgtn">Back to FGTN</Link>
      </div>
    );
  }

  return (
    <div className="fgtn-qr-screen">
      <FgtnQrArt episodeNumber={episodeNumber} url={url} size={qrSize} />
    </div>
  );
}
